/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelUtm } from '../models/ChannelUtm';
import type { UtmCondition } from '../models/UtmCondition';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UtmChannelService {
    /**
     * Add a utm channel
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns ChannelUtm Successfully added a product
     * @throws ApiError
     */
    public static postChannelUtm(
        workspaceId: string,
        requestBody: {
            name: string;
            icon: string;
            conditions: Array<UtmCondition>;
        },
    ): CancelablePromise<ChannelUtm> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/channel-utm',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a utm channel
     * @param id The id of channel-utm to get or update
     * @param workspaceId Workspace ID is required in every request
     * @returns ChannelUtm Successfully retrieved utm channel
     * @throws ApiError
     */
    public static getChannelUtm(
        id: string,
        workspaceId: string,
    ): CancelablePromise<ChannelUtm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/channel-utm/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Utm channel not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a utm channel
     * @param id The id of channel-utm to get or update
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated channel-utm
     * @throws ApiError
     */
    public static patchChannelUtm(
        id: string,
        workspaceId: string,
        requestBody: {
            name?: string;
            icon?: string;
            conditions?: Array<UtmCondition>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/channel-utm/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Utm channel not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a channel
     * @param id The id of channel-utm to get or update
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted channel
     * @throws ApiError
     */
    public static deleteChannelUtm(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/channel-utm/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Channel not found`,
                500: `Internal server error`,
            },
        });
    }
}
